import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UploadState {
  progressBarSteps: any
  highestStepReached: number
  currentStepStatus: any // New property to track current step status
}

const initialState: UploadState = {
  progressBarSteps: null,
  highestStepReached: 0, // Track highest step index
  currentStepStatus: '', // Initialize with empty status
}

const ProgressBarSteps = createSlice({
  name: 'progressBarSteps',
  initialState,
  reducers: {
    progressBarSteps(state, action: PayloadAction<any>) {
      state.progressBarSteps = action.payload
    },
    setHighestStepReached(state, action: PayloadAction<number>) {
      state.highestStepReached = action.payload
    },
    setCurrentStepStatus(state, action: PayloadAction<any>) { // New action
      state.currentStepStatus = action.payload
    },
  },
})

export const { progressBarSteps, setHighestStepReached, setCurrentStepStatus } = ProgressBarSteps.actions
export default ProgressBarSteps.reducer
